module.exports = __webpack_public_path__ + "static/futurewei-logo-f5919df3418fce2c3f85e050ee6bad86.png";